// src/page/operator/OperatorChatPage.js
import ChatBox from "../../components/msg/Chatbox"; // ✅ Import ChatBox

export default function OperatorChatPage() {
  return <ChatBox role="Operator" chatId="client-operator" />; // ✅ Customize role & chatId
}
